<template>
  <div class="d-flex flex-column" style="gap: 8px;">
    <span
      v-if="label"
      class="text-caption text-uppercase font-weight-medium grey--text"
    >
      {{ label }}
    </span>
    <div class="compset-picker d-flex" style="gap: 4px;">
      <div
        v-for="item in options"
        :key="item.value"
        class="compset-picker-item flex-grow-1 rounded d-flex flex-column align-center py-2 px-1 cursor-pointer"
        :class="{ 'compset-picker-item--active': value === item.value }"
        @click="$emit('input', item.value)"
      >
        <div
          class="compset-bars d-flex align-end justify-center mb-1"
          style="gap: 2px; height: 18px;"
        >
          <span
            v-for="(h, bi) in barHeights"
            :key="bi"
            class="compset-bar rounded-sm"
            :class="{
              'compset-bar--highlight': bi === item.barIndex,
              'compset-bar--highlight-active':
                value === item.value && bi === item.barIndex
            }"
            :style="{ height: h + 'px' }"
          />
        </div>
        <span
          class="compset-picker-label text-caption font-weight-bold text-center line-height-1"
        >
          {{ item.label }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Selector de posición en el compset, con las barritas.
 *
 * Estaba embebido en el panel de acción del canvas. Al pasar a valores por
 * ruta hacía falta en dos sitios (el bloque global y cada slot), así que vive
 * aquí con la firma del resto del kit: :value / @input / :label.
 */
export default {
  name: "a-pricing-strategy-rule-type-condition-field-compset",
  props: {
    value: { type: String, default: "middle" },
    // Los valores posibles; las etiquetas salen de i18n
    values: {
      type: Array,
      default: () => ["lowest", "low", "middle", "high", "highest"]
    },
    label: { type: String, default: "" }
  },
  data: () => ({
    barHeights: [5, 8, 12, 15, 18]
  }),
  computed: {
    options() {
      const prefix = "action_compset_pos_";
      return this.values.map((v, i) => ({
        value: v,
        label: this.$te(prefix + v) ? this.$t(prefix + v) : v,
        barIndex: i
      }));
    }
  }
};
</script>

<style lang="scss" scoped>
/* Las variables --rc-* las define .rule-canvas-root y cascadean hasta aquí */
.compset-picker-item {
  min-width: 0;
  border: 1.5px solid var(--rc-border, #e9ebef);
  background: var(--rc-surface, #fff);
  transition: all 0.12s ease;
  &--active {
    border-color: var(--rc-primary, #2e21bd);
    background: var(--rc-primary-bg, rgba(46, 33, 189, 0.06));
    .compset-picker-label {
      color: var(--rc-primary, #2e21bd);
    }
  }
}
.compset-bar {
  width: 4px;
  background: var(--rc-border-dashed, #dfe3e8);
  &--highlight {
    background: var(--rc-text-muted, #8b92a3);
  }
  &--highlight-active {
    background: var(--rc-primary, #2e21bd);
  }
}
.compset-picker-label {
  font-size: 9px !important;
  color: var(--rc-text-mid, #616b7d);
  word-break: break-word;
}
</style>
